export interface Participant {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  secondName?: string;
  birthdate: Date;
  gender: Gender;
  street: string;
  city: string;
  postalcode: string;
  student: Student;
  parentemail: string;
  comment: string;
  dataProtection: boolean;
  swimming?: Swimming;
  photoConsent: {
    participantConsent?: boolean | undefined;
    participantCheckedDate?: Date | undefined;
    parentConsent?: boolean | undefined;
    parentCheckedDate?: Date | undefined;
  }
  registrationDate: Date;
  campRegestrationIDs: string[];
  parentContactInformations?: ParentContact[];
  medical?: Medical;
  food?: Food;
  passport?: Passport;
  subsidy?: Subsidy;
  parentID?: string;
  phoneNumber?: string //TODO: Warum zum hack wurde das Vergessen ???!?!??!!????
}

export enum Gender {
  male = 'male',
  female = 'female',
  diverse = 'diverse',
}

export enum Student {
  student = 'student',
  universityStudent = 'universityStudent',
  trainee = 'trainee',
}

export interface ParentContact {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  isParent: boolean;
}

export interface Medical {
  hasTetanusVaccine: boolean;
  tetanusVaccineDate: string;
  allergies: boolean;
  takingSelfMedicaments: boolean;
  needsHelpMedicaments: boolean;
}

export interface Food {
  allergies: string;
  lactoseIntolerance: boolean;
  fructoseIntolerance: boolean;
  vegetarian: boolean;
  vegan: boolean;
  other: string;
}

export interface Passport {
  pasportNumber: string;
  passportValidUntil: string;
  hasInternationalHealthInsurance: boolean;
  healthInsuranceNumber: string;
}

export interface Subsidy {
  name: string;
  iban: string;
  bic: string;
}

export interface Swimming {
  canSwimm?: boolean | undefined;
  parentAllow?: boolean;
  swimmingPerfomanceVerified?: boolean;
}
